// ===========================================
// Calendar Page Constants
// ===========================================

import { dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import { enUS } from 'date-fns/locale';

// ===========================================
// CALENDAR LOCALIZATION
// ===========================================

const locales = {
  'en-US': enUS,
};

export const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }), // Monday
  getDay,
  locales,
});

// ===========================================
// DRAGGABLE EVENT TYPES
// ===========================================

// Types that can be dragged (lessons only, not placeholders or M&G)
export const DRAGGABLE_TYPES = ['INDIVIDUAL', 'GROUP', 'BAND', 'HYBRID_GROUP'];

// ===========================================
// CALENDAR TIME RANGE
// ===========================================

export const CALENDAR_MIN_TIME = new Date(0, 0, 0, 7, 0); // 7 AM
export const CALENDAR_MAX_TIME = new Date(0, 0, 0, 21, 0); // 9 PM

// ===========================================
// CALENDAR STYLES
// ===========================================

export const calendarPaperStyles = {
  p: 2,
  height: 900, // Increased to accommodate larger time slots
  position: 'relative',
  // 4 timeslots per hour (15 min each) — keep same hour-group height as before
  '& .rbc-time-slot': {
    minHeight: '15px', // 4 × 15px = 60px per hour
  },
  '& .rbc-timeslot-group': {
    minHeight: '60px', // unchanged
  },
  // Day view background - cream/light yellow to match site
  '& .rbc-time-view': {
    backgroundColor: '#FCF6E6',
  },
  '& .rbc-time-content': {
    backgroundColor: '#FCF6E6',
  },
  '& .rbc-time-header': {
    backgroundColor: '#FCF6E6',
  },
  '& .rbc-time-gutter': {
    backgroundColor: '#FCF6E6',
  },
  // Override the light blue day column backgrounds
  '& .rbc-day-slot .rbc-time-slot': {
    backgroundColor: '#FCF6E6',
  },
  '& .rbc-day-slot': {
    backgroundColor: '#FCF6E6',
  },
  '& .rbc-time-header-content': {
    backgroundColor: '#FCF6E6',
  },
  // Fix the white corner cell in top-left
  '& .rbc-time-header-gutter': {
    backgroundColor: '#FCF6E6',
  },
  '& .rbc-label': {
    backgroundColor: '#FCF6E6',
  },
  // Override any remaining blue backgrounds in day/week view
  '& .rbc-today': {
    backgroundColor: '#FCF6E6',
  },
  '& .rbc-allday-cell': {
    backgroundColor: '#FCF6E6',
    display: 'none', // Hide the all-day row
  },
  '& .rbc-row-content': {
    backgroundColor: '#FCF6E6',
  },
  // Hide the all-day section line and vertically center resource headers
  '& .rbc-time-header-content > .rbc-row': {
    minHeight: 'auto',
  },
  '& .rbc-header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: 'none',
    padding: '8px 4px',
  },
  '& .rbc-row.rbc-row-resource': {
    borderBottom: '1px solid #ddd',
  },
  // A draggable tile's time and title sit inside the DnD addon's block wrapper. Give it the
  // layout the library gives `.rbc-event`, so both tile kinds behave alike (#669).
  '& .rbc-day-slot .rbc-addons-dnd-resizable': {
    display: 'flex',
    flexFlow: 'column wrap',
    alignItems: 'flex-start',
  },
};
